import Pqp from "../3x1010/Pqp.js";
import Bout from "./bout/Bout.js";
import Featurer from "./maze/featurer/Featurer.js";
import Maze from "./maze/Maze.js";
import Saver from "./maze/saver/Saver.js";
import PageCommon from "./PageCommon.js";
import Screen from "./screen/Screen.js";
import Helper from "./utils/helper/Helper.js";
import SpriteSheetSlicer from "./utils/SpriteSheetSlicer.js";
import TileWindow from "./utils/tileWindow/TileWindow.js";
import Tool from "./utils/tool/Tool.js";

export default class Game {
	constructor() {
		this.screen = null;
		this.model = null;
		this.sprites = null;
		this.featurer = null;
		this.mainLoopEnabled = false;
		this.savegame = null;
		if (!Game.PROD) {
			window.game = this;
		}
		this.updateId = 0;
		this.previousDelta = 0;
		this.dungeonsCFG = null;
		this.mobCFG = null;
		Game.that = this;

		jQuery(".js-dismiss-text").on("click", this.dismissText.bind(this))
		//window.localStorage.removeItem("savegame")
		jQuery(".js-inst-toggler").css("background-image", "url('assets/ui/toggler.png')");
		jQuery(".js-inst-toggler").on("click", this.toggleIns.bind(this));

		if (Game.ITCHIO) {
			this.dismissText();

		}


		Game.savegame = window.localStorage.getItem("savegame");
		if (Game.savegameTest) {
			Game.savegame = Game.savegameTest;
		}

		//console.log(Game.savegame)
		if (!Pqp.isNullOrEmpty(Game.savegame)) {
			//console.log(Game.savegame)
			Game.savegame = JSON.parse(Game.savegame);
		}
		//console.log(Game.savegame)

		console.log("%cHey you, get your damn hands off her!", "font-size:32px;color: red ;");
		console.log("I know that you are looking for a way to cheat, maybe by adding hit points or base damage!\nDon't you feel guilty?\nProbably not.\nIn fact I would have done the same!\nHowever I bet you can complete this game also without cheating!")

		window.idkfa = Game.that.idkfa;

	}
	toggleIns() {
		let mc = jQuery(".js-to-toggle-ins");
		if (mc.is(":visible")) {
			jQuery(".js-inst-toggler").removeClass("toggler-up");
			mc.slideUp();
		} else {
			jQuery(".js-inst-toggler").addClass("toggler-up");
			
			mc.slideDown();
		}
	}


	idkfa() {
		let message = "Nice one, you have discovered a cheat, you need to enable it by typing idkfa() and press enter!";
		//Game.that.hero
		Game.that.bout.player.hp = 1000;
		Game.that.bout.player.max_hp = 1000;
		console.log("With 1000 HP you can't fail! Happy hunting cheater!")
	}

	dismissText() {
		jQuery(".js-instructions").remove();
	}

	init() {
		if (Pqp.isMobile()) {
			Helper.alert("Sorry!", "No mobile/touch version for the moment!", null, 0);
			return
		}

		this.savegame = Game.savegame;

		jQuery("html").addClass("noselect");
		jQuery("body").addClass("noselect");

		if (Pqp.getParameterByName("tool") === "true") {
			let tool = new Tool();
			tool.init()
			return;
		}
		this.loadCSV();


	}


	loadCSV() {
		let url = Game.URL_CFG;
		$.ajax({
			type: "GET",
			url: url,
			success: this.csvLoaded.bind(this),
			error: this.errorLoadinCore.bind(this)
		});

	}

	errorLoadinCore(e) {
		Helper.alert("Critical!", "Error loading core resources, please try again!", this.errorLoadinCoreFeedback.bind(this), 1);
	}

	errorLoadinCoreFeedback() {
		document.location.reload();
	}

	csvLoaded(data) {
		let csv = $.csv.toArrays(data);
		//console.log(csv);
		this.dungeonsCFG = Helper.toArrayObject(csv);
		this.loadMobs()


		//this.loadAtlas("assets/atlas.json");
	}

	loadMobs() {
		let url = Game.URL_MOBS;
		$.ajax({
			type: "GET",
			url: url,
			success: this.mobsLoaded.bind(this),
			error: this.errorLoadinCore.bind(this)
		});

	}

	mobsLoaded(data) {
		let csv = $.csv.toArrays(data);
		//console.log(csv);
		this.mobCFG = Helper.toArrayObject(csv);


		this.loadAtlas("assets/atlas.txt?v=1.0");
	}



	loadAtlas(file) {
		jQuery.getJSON(file, null, this.atlasLoaded.bind(this, false));
	}

	atlasLoaded(noLocalstorage, data) {
		this.itemAtlas = data;
		//console.log(this.savegame)
		//console.log(!noLocalstorage)
		if ((this.savegame) && (!noLocalstorage)) {
			this.askResume();
		} else {
			this.initBout();
		}

	}

	initBout() {
		this.bout = new Bout(this.itemAtlas, this.dungeonsCFG, this.mobCFG, this.savegame);
		this.bout.init();
		this.createFeaturer();
		jQuery(".js-text-preloading").text("Computing... (have faith)")
		setTimeout(this.loadAssets.bind(this), 100);
	}

	loadAssets() {
		let sheets = Game.SHEETS.slice();
		//console.log(sheets)
		let a = this.itemAtlas.assets;

		/*let toAdd = new Array();
		for (let x = 0; x < a.length; x++) {
			if (toAdd.indexOf(a[x].sheet) < 0){
				toAdd.push(a[x].sheet);
			}
		}
		for (let x = 0; x < toAdd.length; x++) {
			let o = { id: toAdd[x], file: this.itemAtlas.sheets.path + toAdd[x] + ".png", width: 128, height: 128 };
			sheets.push(o);
		}*/

		this.sprites = new SpriteSheetSlicer(this.createComplexAssets.bind(this));
		this.sprites.init(sheets);
	}

	createComplexAssets() {
		this.toRemove = null;
		this.toCreate = [
			//{ id: "map", h: Game.AREA_GAME_ROWS + 1, w: Game.AREA_GAME_COLS },
			{ id: "map", h: 16, w: 15 },
			{ id: "inventory", h: 6, w: 8 },
			{ id: "paperdoll", h: 11, w: 8 },
			{ id: "status", h: 9, w: 8 },
			{ id: "actions", h: 4, w: 8 },
			{ id: "skills", h: 16, w: 12 },
			{ id: "item4", h: 4, w: 12 },
			{ id: "item5", h: 5, w: 12 },
			{ id: "item6", h: 6, w: 12 },
			{ id: "item7", h: 7, w: 12 },
			{ id: "item8", h: 8, w: 12 },
			{ id: "item9", h: 9, w: 12 },
			{ id: "item10", h: 10, w: 12 },
			{ id: "item11", h: 11, w: 12 },
			{ id: "item12", h: 12, w: 12 },
			{ id: "item13", h: 13, w: 12 },
			{ id: "item14", h: 14, w: 12 },
			{ id: "item15", h: 15, w: 12 },
			{ id: "item16", h: 16, w: 12 },
		]
		this.complexAssetIndex = 0;

		if (!Game.DEBUG_CREATE_WINDOWS_FOR_STATIC) {
			this.toCreate = new Array();
		}

		this.createNextComplexAsset()
	}
	createNextComplexAsset() {
		if (this.complexAssetIndex < this.toCreate.length) {
			let id = this.toCreate[this.complexAssetIndex].id;
			let w = this.toCreate[this.complexAssetIndex].w;
			let h = this.toCreate[this.complexAssetIndex].h;
			let win = new TileWindow(jQuery(".js-screen-tilemap"), h, w, this.sprites);
			win.init("");
			this.tmpCount = 0;
			this.toRemove = win;
			//console.log(window.devicePixelRatio);
			html2canvas(jQuery(".js-window-tiles-lower", win.mc).get(0),
				{ allowTaint: true, backgroundColor: "rgba(0,0,0,0)", scale: 1 }).then((canvas) => {
					this.gotWin(canvas, "lower");
				});
			html2canvas(jQuery(".js-window-tiles-upper", win.mc).get(0),
				{ allowTaint: true, backgroundColor: "rgba(0,0,0,0)", scale: 1 }).then((canvas) => {
					this.gotWin(canvas, "upper");
				});
		} else {
			this.sprites.addComplexAssets(this.toCreate);
			this.assetsReady();
		}

	}

	gotWin(canvas, prop) {
		this.tmpCount++;
		this.toCreate[this.complexAssetIndex][prop] = canvas.toDataURL();
		console.log(this.toCreate[this.complexAssetIndex].id)
		console.log(prop)
		console.log(canvas.toDataURL())

		if (this.tmpCount === 2) {
			this.toRemove.destroy();
			this.complexAssetIndex++;
			this.createNextComplexAsset();
		}
	}

	assetsReady(lRebuild = false) {
		if (!Bout.getStatistic(Bout.STAT_START_TIME)) {
			Bout.setStatistic(Bout.STAT_START_TIME, (new Date()).getTime());
		}

		PageCommon.showPreloader(false);
		this.createScreen();
		this.createModel(lRebuild);
		this.initAll();
	}

	createScreen() {
		this.screen = new Screen(this.sprites, this.handleScreenEvents.bind(this));
	}
	createFeaturer() {
		let save = this.savegame;
		this.featurer = new Featurer(this.mazeEventsHandler.bind(this), this.dungeonsCFG);
		if (!save) {
			this.featurer.init();
		} else {
			this.featurer.init(save.featurer.dungeon, save.featurer.gameLevel, save.featurer.levelRow, save.featurer.levelCol);
		}
	}

	createModel(lRebuild = false) {
		let save = this.savegame;
		this.savegame = null;

		let initer
		if (!save) {
			initer = this.featurer.getNextLevel(lRebuild);
		} else {
			initer = save.initer;
			let styler = Saver.setStyler(save.initer);
			initer.styler = styler;
			initer.eventsHandler = this.mazeEventsHandler.bind(this);
		}
		//console.log(initer)

		initer.prefabric = save;
		this.model = new Maze(initer);
	}


	initAll() {
		this.startGenerationTime = new Date().getTime();
		this.screen.init(this.model, this.featurer);
		this.model.init();
	}

	mazeEventsHandler(e) {
		this.screen.mazeEventsHandler(e);
	}

	handleScreenEvents(e) {
		if (e.type === Screen.EVENT_MODEL_READY) {
			this.modelReady();
		}
		if (e.type === Screen.EVENT_MODEL_READY) {
			this.screenReady();
		}
		if (e.type === Screen.EVENT_LEVEL_COMPLETED) {
			this.screen.levelCompleted();
		}
		if (e.type === Screen.EVENT_GO_NEXT_LEVEL) {
			this.mainLoopEnabled = false;
			this.screen.destroy();
			let det = Game.that.featurer.getCurrentLevelDetails();
			//console.log(det)
			Bout.incStatistic(Bout.STAT_SCORE, Game.SCORE_PER_LEVEL[parseInt(det.level)]);


			//console.log(det.end)
			if (det.end === "true") {
				this.createScreen();
				this.screen.openStats(true);
				Helper.alert("Congratulations!", "You've done it! Thanks for playing, this was just a small demo.<br>Would you like to play again?", this.callbackEndDungeon.bind(this), 2);
				this.screen.winStats.mc.css("z-index", 10000000)
				jQuery("body").append(this.screen.winStats.mc);
				let pos = jQuery(".win-confirm").offset();
				console.log(pos)
				this.screen.winStats.mc.css({
					top: Math.floor((jQuery(window).height() - this.screen.winStats.mc.height()) / 2),
					left: Math.floor((jQuery(window).width() - this.screen.winStats.mc.width()) / 2) - jQuery(".win-confirm").width() - 32
				})
			} else {
				this.assetsReady();
			}

		}
		if (e.type === Screen.EVENT_REBUILD_MAZE) {
			this.mainLoopEnabled = false;
			this.screen.destroy();
			this.assetsReady(true);
		}

		if (e.type === Screen.EVENT_RETRY_LEVEL) {
			PageCommon.showPreloader(true);
			this.savegame = JSON.parse(e.data.save);
			//console.log(Game.savegame)
			this.mainLoopEnabled = false;
			this.screen.destroy();
			//this.assetsReady();
			this.atlasLoaded(true, this.itemAtlas);
		}

	}

	callbackEndDungeon(ris) {
		if (ris) {
			document.location.reload();
		} else {
			document.location.href = "https://www.3x1010.it";
		}

	}

	modelReady() {
		this.screen.build();
	}

	screenReady() {
		if (!Game.PROD) {
			console.log("Build time: " + (new Date().getTime() - this.startGenerationTime));
		}
		this.mainLoopEnabled = true;
		this.screen.initAis();
		this.initMainLoop();
	}

	initMainLoop(currentDelta) {
		//requestAnimationFrame(this.mainLoop.bind(this));
		//setTimeout(this.mainLoop.bind(this), 16.5);
		this.updateId = requestAnimationFrame(this.initMainLoop.bind(this));

		let delta = currentDelta - this.previousDelta;

		if (Game.GAME_FPS_LIMIT && delta < Math.floor(1000 / Game.GAME_FPS_LIMIT)) {
			return;
		}

		this.mainLoop();

		this.previousDelta = currentDelta;

	}





	mainLoop() {
		if (this.mainLoopEnabled) {
			this.screen.mainLoop();
			//this.initMainLoop();
		}
	}


	askResume() {
		Helper.alert("Found a savegame!","Would you like to continue or would you like to restart (in the latter case you will lose your savegame)?",this.continueOrRestart.bind(this),3);

	}
	continueOrRestart(reply) {
		//console.log(reply)
		if (reply) {
			this.initBout();
		} else {
			this.savegame = null;
			window.localStorage.removeItem("savegame");
			this.initBout();
		}

	}

}

Game.GAME_FPS_LIMIT = 60;
Game.MULT = 1;

Game.AREA_GAME_COLS = 15 * 1 / Game.MULT;
Game.AREA_GAME_ROWS = 15 * 1 / Game.MULT;
//Game.AREA_GAME_COLS = 12;
//Game.AREA_GAME_ROWS = 12;

Game.TILE_WIDTH = 32;
Game.TILE_HEIGHT = 32;



Game.TILE_WIDTH_MAP = 32 * Game.MULT;
Game.TILE_HEIGHT_MAP = 32 * Game.MULT;
Game.MOB_SPRITE_WIDTH_MULT = 3;
Game.MOB_SPRITE_HEIGHT_MULT = 3;

Game.HERO_WIDTH = 24 * Game.MULT;
Game.HERO_HEIGHT = 12 * Game.MULT;

Game.ENEMY_WIDTH = 24 * Game.MULT;
Game.ENEMY_HEIGHT = 12 * Game.MULT;

Game.COLUMN_WIDTH = 32 * Game.MULT;
Game.COLUMN_HEIGHT = 32 * Game.MULT;

Game.DOOR_WIDTH = 32 * Game.MULT;
Game.DOOR_HEIGHT = 32 * Game.MULT;

Game.CHEST_WIDTH = 32 * Game.MULT;
Game.CHEST_HEIGHT = 32 * Game.MULT;

Game.FIREPLACE_WIDTH = 32 * Game.MULT;
Game.FIREPLACE_HEIGHT = 32 * Game.MULT;

Game.WALK_STEP = 4 * Game.MULT;

Game.SHEETS = [
	//	{ id: "master", file: "/assets/tiles/Dungeon_Tileset.png", width: 128, height: 128 },
	{ id: "walls0", file: "assets/tiles/walls0.png?v=1.0", width: 128, height: 128 },
	{ id: "walls1", file: "assets/tiles/walls1.png?v=1.0", width: 128, height: 128 },
	{ id: "walls2", file: "assets/tiles/walls2.png?v=1.0", width: 128, height: 128 },
	{ id: "walls3", file: "assets/tiles/walls3.png?v=1.0", width: 128, height: 128 },
	{ id: "walls4", file: "assets/tiles/walls4.png?v=1.0", width: 128, height: 128 },
	{ id: "fakewall0", file: "assets/tiles/fakewall0.png?v=1.0", width: 128, height: 256 },
	{ id: "fakewall1", file: "assets/tiles/fakewall1.png?v=1.0", width: 128, height: 256 },
	{ id: "fakewall2", file: "assets/tiles/fakewall2.png?v=1.0", width: 128, height: 256 },
	{ id: "fakewall3", file: "assets/tiles/fakewall3.png?v=1.0", width: 128, height: 256 },
	{ id: "fakewall4", file: "assets/tiles/fakewall4.png?v=1.0", width: 128, height: 256 },
	{ id: "enterexit0", file: "assets/tiles/enterexit0.png?v=1.0", width: 128, height: 128 },
	{ id: "enterexit1", file: "assets/tiles/enterexit1.png?v=1.0", width: 128, height: 128 },
	{ id: "enterexit2", file: "assets/tiles/enterexit2.png?v=1.0", width: 128, height: 128 },
	{ id: "columns0", file: "assets/tiles/columns0.png?v=1.0", width: 128, height: 256 },
	{ id: "columns1", file: "assets/tiles/columns1.png?v=1.0", width: 128, height: 256 },
	{ id: "columns2", file: "assets/tiles/columns2.png?v=1.0", width: 128, height: 256 },
	{ id: "columns3", file: "assets/tiles/columns3.png?v=1.0", width: 128, height: 256 },
	{ id: "arch0", file: "assets/tiles/arch0.png?v=1.0", width: 128, height: 128 },
	{ id: "arch1", file: "assets/tiles/arch1.png?v=1.0", width: 128, height: 128 },
	{ id: "arch2", file: "assets/tiles/arch2.png?v=1.0", width: 128, height: 128 },
	{ id: "arch3", file: "assets/tiles/arch3.png?v=1.0", width: 128, height: 128 },
	{ id: "floor0", file: "assets/tiles/floor0.png?v=1.0", width: 128, height: 128 },
	{ id: "floor1", file: "assets/tiles/floor1.png?v=1.0", width: 128, height: 128 },
	{ id: "floor2", file: "assets/tiles/floor2.png?v=1.0", width: 128, height: 128 },
	{ id: "floor3", file: "assets/tiles/floor3.png?v=1.0", width: 128, height: 128 },
	{ id: "floor4", file: "assets/tiles/floor4.png?v=1.0", width: 128, height: 128 },
	{ id: "floor5", file: "assets/tiles/floor5.png?v=1.0", width: 128, height: 128 },
	{ id: "floor6", file: "assets/tiles/floor6.png?v=1.0", width: 128, height: 128 },
	{ id: "floor7", file: "assets/tiles/floor7.png?v=1.0", width: 128, height: 128 },
	{ id: "fireplace", file: "assets/tiles/fireplace.png?v=1.0", width: 128, height: 128 },
	{ id: "doorwoodenopened", file: "assets/tiles/doorWooden.png?v=1.0", width: 128, height: 128 },
	{ id: "doorspikesopened", file: "assets/tiles/doorSpikes.png?v=1.0", width: 128, height: 128 },
	{ id: "doorwooden", file: "assets/tiles/doorWooden.png?v=1.0", width: 128, height: 256 },
	{ id: "doorspikes", file: "assets/tiles/doorSpikes.png?v=1.0", width: 128, height: 256 },
	{ id: "paving0", file: "assets/tiles/paving0.png?v=1.0", width: 128, height: 128 },
	{ id: "paving1", file: "assets/tiles/paving1.png?v=1.0", width: 128, height: 128 },
	{ id: "paving2", file: "assets/tiles/paving2.png?v=1.0", width: 128, height: 128 },
	{ id: "paving3", file: "assets/tiles/paving3.png?v=1.0", width: 128, height: 128 },
	{ id: "paving4", file: "assets/tiles/paving4.png?v=1.0", width: 128, height: 128 },
	{ id: "paving5", file: "assets/tiles/paving5.png?v=1.0", width: 128, height: 128 },
	{ id: "paving6", file: "assets/tiles/paving6.png?v=1.0", width: 128, height: 128 },
	{ id: "hero", file: "assets/chars/hero.png?v=1.0", width: 384, height: 384 },
	{ id: "slime", file: "assets/chars/slime.png?v=1.0", width: 384, height: 384 },
	{ id: "orc", file: "assets/chars/orc.png?v=1.0", width: 384, height: 384 },
	{ id: "sniper", file: "assets/chars/sniper.png?v=1.0", width: 384, height: 384 },
	{ id: "rat", file: "assets/chars/rat.png?v=1.0", width: 384, height: 384 },
	{ id: "bat", file: "assets/chars/bat.png?v=1.0", width: 384, height: 384 },
	{ id: "goblin", file: "assets/chars/goblin.png?v=1.0", width: 384, height: 384 },
	{ id: "troll", file: "assets/chars/troll.png?v=1.0", width: 384, height: 384 },
	{ id: "spider", file: "assets/chars/spider.png?v=1.0", width: 384, height: 384 },
	{ id: "dead", file: "assets/chars/dead.png?v=1.0", width: 384, height: 384 },
	{ id: "torch", file: "assets/tiles/torch.png?v=1.0", width: 128, height: 128 },
	{ id: "chests", file: "assets/tiles/chests.png?v=1.0", width: 128, height: 128 },
	{ id: "warned", file: "assets/misc/warned.png?v=1.0", width: 384, height: 384 },
	{ id: "wintileset", file: "assets/ui/wintileset.png?v=1.0", width: 128, height: 128 },
	{ id: "items", file: "assets/items/_items.png?v=1.0", width: 128, height: 128 },
	{ id: "spikes", file: "assets/tiles/spikes.png?v=1.0", width: 128, height: 128 },
	{ id: "furniture", file: "assets/tiles/furniture.png?v=1.0", width: 128, height: 128 }
];

Game.SCORE_TORCH_LIT = 100;
Game.SCORE_COOK = 200;
Game.SCORE_CHEST_OPENED = 500;
Game.SCORE_SECRET_DISCOVERED = 2000;
Game.SCORE_PER_LEVEL = [
	1000,
	2000,
	3000,
	4000,
	5000,
	6000,
	7000,
	8000,
	9000,
	10000,
	11000,
	12000,
	13000,
	14000,
	15000
]


Game.LABEL_LEVELS = 15;

//Game.URL_CFG = "https://docs.google.com/spreadsheets/d/e/2PACX-1vSR69S9u3T0WQFdoVGBuOjWBnuvScDdv4gOomDeYO4WvQ_0ADo4JdCPSbWfapEZDRQZiItnRMt8tZso/pub?gid=0&single=true&output=csv&rnd=" + (new Date()).getTime();
//Game.URL_MOBS = "https://docs.google.com/spreadsheets/d/e/2PACX-1vSR69S9u3T0WQFdoVGBuOjWBnuvScDdv4gOomDeYO4WvQ_0ADo4JdCPSbWfapEZDRQZiItnRMt8tZso/pub?gid=1300817174&single=true&output=csv&rnd=" + (new Date()).getTime();
Game.URL_CFG = "assets/levels.txt?rnd=" + (new Date()).getTime();
Game.URL_MOBS = "assets/stats.txt?rnd=" + (new Date()).getTime();

Game.DEBUG_MOB_CELLS = false;
Game.DEBUG_NO_COLLISION = false;
Game.DEBUG_NO_POI = false;
Game.DEBUG_INSTANT_WIN = false;
Game.DEBUG_CREATE_WINDOWS_FOR_STATIC = false;
Game.DEBUG_USE_WIN_STATIC = true;
Game.PROD = true;
Game.ITCHIO = true;

// PROD
/*
Game.DEBUG_MOB_CELLS = false;
Game.DEBUG_NO_COLLISION = false;
Game.DEBUG_NO_POI = false;
Game.DEBUG_INSTANT_WIN = false;
Game.DEBUG_CREATE_WINDOWS_FOR_STATIC = false;
Game.DEBUG_USE_WIN_STATIC = true;

*/

//Game.savegameTest = (``);

